import clsx from 'clsx';
import { switchStyle } from './switch.style';

type TextSwitchProps = {
	list: Array<{
		text: string;
		icon?: React.ReactNode;
	}>;
	selectedIndex: number;
	handleClick: (index: number) => void;
}

export const TextSwitch = ({
	list = [{ text: 'button1' }, { text: 'button2' }],
	selectedIndex = 0,
	handleClick,
}: TextSwitchProps) => {

	const onClick = (index: number) => () => {
		handleClick(index)
	}

	return (
		<div className={clsx('text-switch', switchStyle.textSwitch)} data-selected={selectedIndex}>
			{list.map((item, index) => (
				<div
					key={index}
					className={clsx('text-switch__btn', switchStyle.textSwitchButton)}
					data-selected={index === selectedIndex}
					onClick={onClick(index)}
				>
					{item.icon ? item.icon : null}
					<span className={clsx('text-switch__text', switchStyle.textSwitchText)}>{item.text}</span>
				</div>
			))}
			<div
				className="text-switch__indicator"
				style={{
					transform: `translateX(${100 * selectedIndex}%)`,
					width: `${100 / list.length}%`,
				}}
			/>
		</div>
	)
}